import {http} from "@/api/http";
import {API_URL} from "@/api/base";


export async function getOffers(company_id, order_type, store_ids, product_ids, profit_params){
    const data = {
        stores: store_ids,
        products: product_ids,
        ...(profit_params ? { profit_params } : {})
    }
    const size = store_ids.length * product_ids.length
    return await http.post(
        `${API_URL}/v1/offer/list?company_id=${company_id}&order_type=${order_type}&size=${size}`,
        data    )
}

export async function setOffers(company_id, offers){
    return await http.post(
        `${API_URL}/v1/offer/set-offers?company_id=${company_id}`,
        offers    )
}

export async function setOzonOldPrices(company_id, offers){
    return await http.post(
        `${API_URL}/v1/offer/set-ozon-old-prices`,
        {company_id, offers}    )
}

export async function setDiscountSync(company_id, offer_ids, enabled){
    return await http.post(
        `${API_URL}/v1/offer/discount-sync`,
        {company_id, offer_ids, enabled}    )
}
